<template>
	<div>
		<h3 class="title mb_10 tal">{{ title }}</h3>
		<p class="mb_10">
			{{ description }}
		</p>
		<div v-for="(field, idx) in fields" :key="field.seq" class="d_flex mb_20">
			<div class="w100">
				<p class="mb_10">{{ field.title }}</p>
				<input
					type="text"
					:required="!readonly && field.is_required === 'Y'"
					:readonly="readonly"
					v-model="field_values[idx].value"
				/>
			</div>
		</div>
	</div>
</template>

<script>
export default {
	props: {
		fields: {
			type: Array,
			defayult: () => [],
		},
		title: {
			type: String,
			default: '',
		},
		description: {
			type: String,
			default: '',
		},
		modelValue: {
			type: Array,
			default: () => [],
		},
		readonly: {
			type: Boolean,
			default: false,
		},
	},
	computed: {
		field_values: {
			get() {
				return this.initFieldValues(this.modelValue);
			},
			set(value) {
				this.$emit('update:modelValue', value);
			},
		},
	},
	watch: {
		fields: {
			handler() {
				this.field_values = this.initFieldValues(this.modelValue);
			},
			immediate: true,
		},
	},
	methods: {
		initFieldValues(data) {
			if (data && data.length) return data;

			return this.fields.map(field => ({
				field_seq: field.seq,
				value: '',
			}));
		},
	},
};
</script>
